var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnion = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 20",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C3.44772 0 3 0.447715 3 1V15H2.88963H0.889288C0.713768 15.0009 0.542437 15.0548 0.396883 15.155C0.251329 15.2552 0.138067 15.3972 0.0713708 15.563C0.0216011 15.6708 -0.00275761 15.789 0.000247442 15.9081C-0.000429028 16.0277 0.0219973 16.1461 0.06624 16.2568C0.110483 16.3674 0.175672 16.4681 0.258069 16.5529L3.36971 19.7314C3.45236 19.8165 3.55069 19.8841 3.65902 19.9302C3.76736 19.9763 3.88357 20 4.00093 20C4.11829 20 4.2345 19.9763 4.34283 19.9302C4.45117 19.8841 4.5495 19.8165 4.63215 19.7314L7.74379 16.5529C7.86715 16.4252 7.95072 16.263 7.98395 16.0869C8.01717 15.9107 7.99857 15.7284 7.93049 15.563C7.86379 15.3972 7.75053 15.2552 7.60498 15.155C7.45942 15.0548 7.28809 15.0009 7.11257 15H5.11223H5V1C5 0.447715 4.55228 0 4 0Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnion);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Union.47c02c4577bb9c5d77f514a82dd01126.svg";